import { useNullableContext } from '~/common/contexts/nullableContext';
import { IconRepository } from '~/core/shared/types';
import { IconRepositoryContext } from '../../IconRepositoryContext';

export const useIconRepository = (): IconRepository => {
  const { iconRepository } = useNullableContext(
    IconRepositoryContext,
    'useIconRepository must be used within an IconRepositoryProvider',
  );

  return iconRepository;
};
